<template>
  <div class="google-sign-in" @click="signIn()">
    <img class="g-icon" src="@/assets/search.svg" alt="G sign" />
    <p>SignIn with Google</p>
  </div>
  <!-- <div class="custom-fab white-bg br-50 smooth-shadow" @click="signIn()">
    <img src="@/assets/search.svg" alt="G sign" />
  </div> -->
</template>

<script>
import Vue from "vue";

export default {
  methods: {
    signIn() {
      this.$gAuth
        .signIn()
        .then((googleUser) => {
          this.$emit("success", googleUser.getAuthResponse().id_token);
        })
        .catch((error) => {
          // things to do when sign-in fails
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.google-sign-in {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: var(--color-info);
  border-radius: 50px;
  padding: 5px;
  box-shadow: 0 5px 6px rgba(17, 83, 206, 0.219);
  transition: 0.2s all ease-in-out;

  &:hover {
    cursor: pointer;
    box-shadow: 0 10px 6px rgba(17, 83, 206, 0.219);
  }

  &:active {
    transform: scale(0.95);
  }

  .g-icon {
    width: 20px;
    height: 20px;
    padding: 7px;
    background: white;
    border-radius: 50%;
  }

  p {
    margin: 0;
    color: white;
    margin: 0 10px 0 10px;
  }
}
</style>
